import { Ref } from 'vue';
import { usePlocState, getStore } from '@hfc/ui-core';
import { MedicareConsentStore, MedicareConsentStoreInterface } from '@/consent/medicare/infrastructure/store/MedicareConsentStore';

interface UseMedicareConsentStoreInterface {
  medicareConsentStore: MedicareConsentStore;
  medicareConsentState: Ref<MedicareConsentStoreInterface>;
}

export const useMedicareConsentStore = (): UseMedicareConsentStoreInterface => {
  const medicareConsentStore = getStore<MedicareConsentStore>('MedicareConsentStore', MedicareConsentStore);
  const medicareConsentState = usePlocState(medicareConsentStore) as Ref<MedicareConsentStoreInterface>;

  return {
    medicareConsentStore,
    medicareConsentState,
  };
};
